import gql from 'graphql-tag';

const DELETE_RESOURCE_FAVORITE = gql`
  mutation deleteResourceFavorite($where: ResourceFavoriteDeleteInput!) {
    deleteResourceFavorite(where: $where) {
      id
      resourceId
    }
  }
`;

export default DELETE_RESOURCE_FAVORITE;
